var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { PeriodComparisonSplitColumnTooltip } from '@web/components/layout/RechartsItems/PeriodComparisonSplitColumnTooltip';
import { TIME_SPENT_BY_ACTIVITY_TYPE_COLORS_CONFIG } from '@web/config';
import { ComparisonPeriod, getPeriodComparisonSection } from '@web/utility/ tooltip/periodComparisonTooltip';
import { formatDuration } from '@workalizer/shared/utils';
var resolveActivityTypeSwatchColor = function (dataKey, metricKey, stripeSwatchColors) {
    var key = metricKey;
    var section = getPeriodComparisonSection(dataKey);
    var stripeColor = stripeSwatchColors === null || stripeSwatchColors === void 0 ? void 0 : stripeSwatchColors[dataKey];
    if (section === ComparisonPeriod.Team) {
        return {
            stripe: true,
            color: stripeColor !== null && stripeColor !== void 0 ? stripeColor : TIME_SPENT_BY_ACTIVITY_TYPE_COLORS_CONFIG[key].teamChartColor
        };
    }
    if (section === ComparisonPeriod.Previous) {
        return {
            color: TIME_SPENT_BY_ACTIVITY_TYPE_COLORS_CONFIG[key].prevChartColor
        };
    }
    return {
        color: TIME_SPENT_BY_ACTIVITY_TYPE_COLORS_CONFIG[key].chartColor
    };
};
export function TimeSpentByActivityTypeTooltip(_a) {
    var seriesOrder = _a.seriesOrder, metricLabels = _a.metricLabels, stripeSwatchColors = _a.stripeSwatchColors, showTeamAverage = _a.showTeamAverage, dateFrom = _a.dateFrom, dateTo = _a.dateTo, t = _a.t, tooltipProps = __rest(_a, ["seriesOrder", "metricLabels", "stripeSwatchColors", "showTeamAverage", "dateFrom", "dateTo", "t"]);
    return (_jsx(PeriodComparisonSplitColumnTooltip, __assign({}, tooltipProps, { seriesOrder: seriesOrder, metricLabels: metricLabels, showTeamAverage: showTeamAverage, dateFrom: dateFrom, dateTo: dateTo, t: t, formatValue: function (value) { return formatDuration(value, 'hours'); }, resolveSwatchColor: function (dataKey, metricKey) {
            return resolveActivityTypeSwatchColor(dataKey, metricKey, stripeSwatchColors);
        } })));
}
